import appSettings from "../settings/appSettings";
import fetchRequest from "./fetchRequest";
import { wvusLogger } from "../helpers";
import eletterTopicTemplates from "../components/TourApp/SAK/Questionnaire/eletterTopicTemplates.json";
import { getStateName } from "../helpers/data-utils/stateNameLookup";
import { processSponsorMessage } from "../helpers/data-utils/sponsorMessage";

export async function requestSakEletter({
  childId,
  countryCode,
  orderRef,
  cssc,
  orderHandshake,
  mediaUrl,
  mediaHandshake,
  sponsorName,
  childName,
  sakQuestionnaireData,
  sakSponsorData
}) {
  const { eventsServiceConfig } = appSettings;
  const { baseUrl, apiKey } = eventsServiceConfig;
  const queryParams = [
    ["handshake", encodeURIComponent(orderHandshake)],
    ["identifier", encodeURIComponent(orderRef)],
    ["marker", encodeURIComponent(cssc)]
  ]
    .map(([key, value]) => `${key}=${value}`)
    .join("&");
  const url = `${baseUrl}/eletters?${queryParams}`;

  // Get template and compose letter
  const { topic, response } = sakQuestionnaireData;
  const { state: stateCode } = sakSponsorData;
  const topicTemplate = eletterTopicTemplates[topic]?.template;

  if (!topicTemplate) {
    throw new Error(`No template found for topic: ${topic}`);
  }

  const letterText = topicTemplate
    .replace(/\[sponsorName\]/g, sponsorName)
    .replace(/\[sponsorState\]/g, getStateName(stateCode))
    .replace(/\[response\]/g, processSponsorMessage(response))
    .replace(/\[childName\]/g, childName);

  const apiPayload = {
    childNumber: `${countryCode}-${childId}`,
    countryCode: countryCode,
    orderReferenceNumber: orderRef,
    campaignSourceCode: cssc,
    handshake: orderHandshake,
    eventSubject: "accordion/saki-v1/sendLetter",
    letterText: letterText,
    mediaUrl1: mediaUrl,
    mediaHandshake1: mediaHandshake
  };

  // Log Request
  wvusLogger.log(
    JSON.stringify({
      description: "Sending SAK eletter request to events service",
      url,
      apiPayload
    }),
    wvusLogger.getLogLevelNames().INFO
  );

  try {
    const response = await fetchRequest(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "ocp-apim-subscription-key": apiKey
      },
      body: JSON.stringify(apiPayload),
      cache: "no-cache",
      mode: "cors",
      timeout: 15 * 1000
    });

    if (!response.ok) {
      throw new Error("Failed to send SAK eletter");
    }

    const respData = await response.json();

    if (!respData || !respData.letterId) {
      throw new Error("Invalid SAK eletter response");
    }

    return respData;
  } catch (err) {
    wvusLogger.log(err, wvusLogger.getLogLevelNames().ERROR);
    console.error(err);
    return Promise.reject(err);
  }
}
